/**
 * Resolve the active brand label in both webpack bundles and Vite development.
 *
 * @returns Active label name.
 */
export default function getActiveLabel(): string {
	if (typeof window !== 'undefined') {
		const requestLabel = window.__CREATOR_LABEL__
			?? document.documentElement.getAttribute('data-label');

		if (requestLabel) {
			return requestLabel;
		}
	}

	return LABEL;
}
